import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Order extends CRUDService {
  constructor() {
    super(APIPath.orders);
  }

  orderAction = (orderId, data) =>
    BaseService.put(`${APIPath.orders}/${orderId}/action`, data);

  resumeFulfillment = data =>
    BaseService.post(`${APIPath.orders}/resume-fulfillment`, data);

  refreshUnassignedAllocations = data =>
    BaseService.post(`${APIPath.orders}/allocations/unassigned/refresh`, data);

  getUnassignedAllocationRefreshStatus = params =>
    BaseService.get(
      `${APIPath.orders}/allocations/unassigned/refresh/status?${CommonUtility.objectToParams(
        params,
      )}`,
    );

  orderDetail = (orderId, params) => {
    const url = `orders/${orderId}/?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  };

  fulfillTote = (orderId, data) => {
    const url = `${APIPath.orders}/${orderId}/allocations/ship`;
    return BaseService.put(url, data);
  };

  allocationLogs = (orderId, data) => {
    const url = `${APIPath.orders}/${orderId}/allocationLog`;
    return BaseService.get(url, data);
  };

  updateAddress = (orderId, data) =>
    BaseService.put(`${APIPath.orders}/${orderId}/update/address`, data);

  cancelOrder = (orderId, data) =>
    BaseService.put(`${APIPath.orders}/${orderId}/action`, data);
}

const OrderService = new Order();
Object.freeze(OrderService);
export { OrderService };
